export default `
# O semináři

## Historie

Installfest je akce, kde se setkávají začátečníci s ostřílenými linuxáky, kteří jim pomáhají s
instalací GNU/Linux nebo problémy, které vyžadují více zkušeností. InstallFest pořádaný klubem
Silicon Hill je ale o něco více akčnější, kromě instalací nabízí i přednášky a navíc je možné
zúčastnit se i z domova.

Installfest je akce, která má své počátky v Americe. Týká se operačního systému GNU/Linux a jeho
příznivců, kteří často pomáhali svým méně zkušeným kolegům s instalací tohoto operačního systému,
až se jich sešlo více najednou a začali dělat takzvané instalační festivaly, čili installfesty.
Jeden z prvních installfestů probíhal v knihovně. Účastníci si tam donesli své počítače (občas i
rarity a polopočítače) a instalace mohli začít. Ostřílení linuxáci radili svým méně zkušeným kolegům,
ale i mezi sebou si vyměňovali spoustu zajímavých zkušeností a panovala velmi přátelská a vzrušená atmosféra.

Takové installfesty jsou dnes pořádány po celém světě. Mnohdy mezi novinkami naleznete informaci,
že se podařilo uskutečnit první installfest v Egyptě, na Islandu nebo někde úplně v divočině,
kde byste si skoro netroufali doufat, že tam mají vůbec počítače. Ono to nemusí být na první pohled
zřejmé, ale GNU/Linux lidi spojuje. A to velmi často díky atmosféře, která tento populární operačního
systému obklopuje.

## O installfestech

Installfest, čili instalační festival, existuje v různých zemích po celém světě. Vznikl na popud
několika málo nadšenců v dobách, kdy se mezi lidmi začal šířit operační systém GNU/Linux. Ačkoliv
byla instalace a používání pro začátečníky obtížná, byl jejich zájem a touha po tomto systému taková,
že oslovili své kolegy a kamarády, aby jim s instalací pomohli a zasvětili do tajů a kouzel, které přináší.

Jeden z prvních installfestů se konal v Americe v jedné zapadlé knihovně. Lidé se tam jednoduše sešli,
přinesli si vlastní počítače (občas i takové přístroje, které snad ani za počítač považovat nešly) a
společně se s mnoha linuxovými guru, čili odborníky na tento operační systém, vrhli do instalací a
řešení nejběžnějších situací.

Od té doby se lecos změnilo a k pořádání installfestů se přidali i studenti ze
[Studentské unie ČVUT](http://www.su.cvut.cz/), konkrétně z klubu [Silicon Hill](http://www.sh.cvut.cz/).
Zde se tento operační systém též začínal dostávat do povědomí a byl vznesen požadavek na uspořádání
menšího semináře s praktickými ukázkami. Toto se poprvé realizovalo v roce 1999 a hned rok poté akce
vzrostla do mnohem větších rozměrů, která byla určena nejen pro studenty, ale i veřejnost. Tento trend
započal jeden ze studentů, Dušan Talíř. InstallFest v jeho podobě obsahoval kromě instalací za
dohledu odborníků také sérii přednášek na témata používání GNU/Linuxu a nejčastějších problémů či
situací, které nastávají při přechodu z jiného operačního systému. Tento trend se ujal a lidé se
dozvěděli i o tématech souvisejících, například o sázecím systému TeX, o kterém přišel přednášet
[Petr Olšák](http://math.feld.cvut.cz/olsak/), jeden z nejpovolanějších odborníků v této oblasti.

Další InstallFest se konal nikoliv ve strahovské menze, jako jeho předchůdce, ale v jedné z nejlépe
vybavených místností [ČVUT](http://www.cvut.cz/), a to sálu D1 [Fakulty stavební](http://www.fsv.cvut.cz/).
Disponovala především kvalitní ozvučovací technikou a třemi promítacími plátny. Sál taktéž nabízel mnohem
více míst, která bohužel nedostačovala, protože zájem byl obrovský. Na čistě přednáškovou část se
přihlásilo přes 580 lidí. Každý ze dvou dnů a paralelně s tímto programem probíhaly v druhém dni
instalace v počítačové místnosti, kde se vystřídalo okolo stovky účastníků.

Celá akce byla online vysílána do Internetu, o což se postaralo
[Audiovizuální Centrum Silicon Hillu](http://avc.sh.cvut.cz/), čili AVC, ve spolupráci se sdružením
[Cesnet](http://www.cesnet.cz/). Lidé z tohoto projektu zároveň tyto záznamy uveřejnili na svých
stránkách, kde jsou volně ke stažení pro další zájemce nebo i pro účastníky InstallFestu, aby si
mohli zopakovat poznatky či věnovat se důkladněji pasážím, které nestačili během semináře vstřebat.
`



// WEBPACK FOOTER //
// ./src/content/installfest/about/text.js